import React, { useEffect, useState } from "react";
import TiptapEditor from "components/Editor/TiptapEditor";
import style from "./MIN101F1.module.scss";
import { postData } from "../../utils/TransactionUtil";

const MIN101F1 = ({ ntceId }) => {
    const [posts, setPosts] = useState([]);
    const [noticeDtl, setNoticeDtl] = useState(null);  // 초기 상태를 null로 설정

    const handleSave = (content) => {
        setPosts([...posts, { id: Date.now(), content }]);
    };

    useEffect(() => {
        // 데이터를 가져오는 함수 호출
        getNoticeDtl();
    }, []);

    async function getNoticeDtl() {
        const prop = {
            schNtceId: ntceId,
        };
        const res = await postData("/MIN/getNoticeDtl", prop);
        console.log(res);
        setNoticeDtl(res);  // 데이터를 정상적으로 받아오면 상태 업데이트
    }

    // 로딩 페이지 입력 추후 변경 필요
    if (noticeDtl === null) {
        return <div>Loading...</div>;
    }

    return (
        <main className={style.main_wrap}>
            <TiptapEditor
                content={noticeDtl?.pbntCtn || ""}  // qnaDtl이 없을 경우 빈 문자열로 처리
                onUpdate={handleSave}
            />

            {/*<div className="mt-4">*/}
            {/*    {posts.map((post) => (*/}
            {/*        <div key={post.id} className="p-4 border rounded mt-2">*/}
            {/*            <div dangerouslySetInnerHTML={{ __html: post.content }} />*/}
            {/*        </div>*/}
            {/*    ))}*/}
            {/*</div>*/}
        </main>
    );
};

export default MIN101F1;
